import styles from "./page.module.css";
import io from "socket.io-client";
import { useState, useEffect } from "react";
import { Framework } from "@superfluid-finance/sdk-core";
import { ethers } from "ethers";
import { hasFormSubmit } from "@testing-library/user-event/dist/utils";
const socket = io.connect("http://localhost:4000");
const Form = () => {
  const maticxadd = "0x96B82B65ACF7072eFEb00502F45757F254c2a0D4";
  const daixadd = "0x5D8B4C2554aeB7e86F387B4d6c00Ac33499Ed01f";
  const usdcxadd = "0x42bb40bF79730451B11f6De1CbA222F17b87Afd7";

  const [Usdcvalue, setUsdcvalue] = useState("");
  const [Daivalue, setDaivalue] = useState("");
  const [Maticvalue, setMaticvalue] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [thresold, setThresold] = useState("");
  const [option, setOption] = useState("");

  const HandleSubmit = () => {
    const data = {
      email: email,
      user: address,
      threshold: thresold,
      coin: option,
    };
    console.log(data);
    socket.emit("message", data);
  };
  const sendMessage = () => {
    socket.emit("message", {
      user: "0xA2152ADe4a9485B68Ad25c3d98fc05e0741E66E7",
      message: "hello",
    });
  };

  const balance = async (user) => {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    await provider.send("eth_requestAccounts", []);
    const signer = provider.getSigner();

    // const chainId = await window.ethereum.request({ method: "eth_chainId" });
    const sf = await Framework.create({
      chainId: 80001,
      provider: provider,
    });

    const usdcx = await sf.loadSuperToken(usdcxadd);
    const daix = await sf.loadSuperToken(daixadd);
    const maticx = await sf.loadSuperToken(maticxadd);
    const usdctoken = await usdcx.balanceOf({
      account: user,
      providerOrSigner: provider,
    });
    setUsdcvalue(Number(usdctoken / 1e18));
    const daitoken = await daix.balanceOf({
      account: user,
      providerOrSigner: provider,
    });
    setDaivalue(Number(daitoken / 1e18));
    const matictoken = await maticx.balanceOf({
      account: user,
      providerOrSigner: provider,
    });
    setMaticvalue(Number(matictoken / 1e18));
    console.log(usdctoken, daitoken, matictoken);
    // alert(usdctoken, daitoken, matictoken);
  };

  useEffect(() => {
    socket.on("receive_message", (data) => {
      console.log(data);
      alert(data);
    });
  }, [socket]);
  return (
    <div
      style={{
        background: "black",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "100px",
          marginBottom: "500px",
        }}
      >
        <div className={styles.card}>
          <div className={styles.card2}>
            <form className={styles.form}>
              <p id={styles.heading}>Enter Details</p>
              <div className={styles.field}>
                <svg
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  height={16}
                  width={16}
                  xmlns="http://www.w3.org/2000/svg"
                  className={styles.inputicon}
                >
                  <path d="M13.106 7.222c0-2.967-2.249-5.032-5.482-5.032-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.43.199-1.354.328-2.29.328-2.926 0-4.813-1.88-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.416 2.769-.492 0-.772-.28-.772-.76V5.206H8.923v.834h-.11c-.266-.595-.881-.964-1.6-.964-1.4 0-2.378 1.162-2.378 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.11c.081.67.703 1.148 1.503 1.148 1.572 0 2.57-1.415 2.57-3.643zm-7.177.704c0-1.197.54-1.907 1.456-1.907.93 0 1.524.738 1.524 1.907S8.308 9.84 7.371 9.84c-.895 0-1.442-.725-1.442-1.914z" />
                </svg>
                <input
                  type="email"
                  className={styles.inputfield}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="email"
                  autoComplete="off"
                />
              </div>
              <div className={styles.field}>
                <svg
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  height={16}
                  width={16}
                  xmlns="http://www.w3.org/2000/svg"
                  className={styles.inputicon}
                >
                  <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
                </svg>
                <input
                  onChange={(e) => {
                    setAddress(e.target.value);
                    balance(e.target.value);
                  }}
                  className={styles.inputfield}
                  placeholder="Account address"
                />
              </div>

              <div className={styles.field}>
                <div style={{ color: "white" }}>Select coin </div>

                <select
                  name="slct"
                  className={styles.inputfield}
                  onChange={(e) => {
                    setOption(e.target.value);
                  }}
                  id="slct"
                >
                  <option
                    value="0x96B82B65ACF7072eFEb00502F45757F254c2a0D4"
                    style={{ color: "black", marginTop: "5px" }}
                  >
                    MATICx {Maticvalue}
                  </option>
                  <option
                    value="0x42bb40bF79730451B11f6De1CbA222F17b87Afd7"
                    style={{ color: "black", marginTop: "5px" }}
                  >
                    USDCx {Usdcvalue}
                  </option>
                  <option
                    value="0x5D8B4C2554aeB7e86F387B4d6c00Ac33499Ed01f"
                    style={{ color: "black", marginTop: "5px" }}
                  >
                    DAIx {Daivalue}
                  </option>
                </select>
              </div>
              <div className={styles.field}>
                <input
                  type="number"
                  onChange={(e) => {
                    setThresold(e.target.value);
                  }}
                  className={styles.inputfield}
                  placeholder="Thresold amount"
                />
              </div>
              <div className={styles.btn}>
                {/* <button className={styles.button1}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;submit&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button> */}
                {/* <button className={styles.button2}>Sign Up</button> */}
              </div>

              <button
                onClick={() => {
                  HandleSubmit();
                  // sendMessage();
                }}
                className={styles.button3}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>

      <div>Powerd by superfluid</div>
    </div>
  );
};
export default Form;
